"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Server = exports.Discovery = void 0;
var axios_1 = __importDefault(require("axios"));
var firebase_functions_1 = __importDefault(require("firebase-functions"));
// comment in to test firebase config
// const firebase = {
//   config: () => {
//     return require('../firebase-config-mock.json')
//   }
// }
var Discovery = /** @class */ (function () {
    function Discovery() {
        var _this = this;
        this.Interval = 1000 * 60 * 5;
        this.Retry = 5;
        this.KeepUpToDateDefault = true;
        this.DefaultURLs = ['https://aisw-ww-ENVIRONMENT.ew.r.appspot.com'];
        this.source = '';
        this.instanceId = Math.random() * 1000;
        /**
         * Request all APIs and write them into process.env
         * Uses process.env.environment as default environment
         * if env is not provided in init call.
         * Will attempt 5 retries to reach one of the DefaultURLs
         *
         * Will throw an error if env was not given or if no
         * discovery service responded
         */
        this.init = function (env, keepUpToDate) {
            if (keepUpToDate === void 0) { keepUpToDate = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var useFirebaseEnvironment, baseUrl, environment, discoveryEnv_1, apis_1, source, i, index, url, err_1;
                var _this = this;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            useFirebaseEnvironment = false;
                            environment = env || process.env.environment || ((_a = process.env.ProjectId) === null || _a === void 0 ? void 0 : _a.substring(process.env.ProjectId.lastIndexOf('-') + 1));
                            if (!environment) {
                                console.warn('The environment parameter, process.env.environment and process.env.ProjectId are all not defined, which means the discovery used fallback to prod');
                                environment = 'prod';
                                process.env.ProjectId = 'aisw-ww-prod';
                            }
                            try {
                                useFirebaseEnvironment = firebase_functions_1.default.config().discovery;
                            }
                            catch (error) {
                                // console.log('Not using Firebase-Environment. Reason:', error)
                                console.log('Not using Firebase-Environment. Firebase.config is not available.', error);
                            }
                            if (!useFirebaseEnvironment) return [3 /*break*/, 1];
                            discoveryEnv_1 = firebase_functions_1.default.config().discovery[environment];
                            Object.keys(discoveryEnv_1).forEach(function (envEntryName) {
                                if (discoveryEnv_1[envEntryName]) {
                                    process.env[envEntryName] = discoveryEnv_1[envEntryName];
                                    _this[envEntryName] = discoveryEnv_1[envEntryName];
                                    // exports[envEntryName] = discoveryEnv[envEntryName]
                                }
                                // }
                            });
                            this.source = 'localFirebase';
                            return [3 /*break*/, 8];
                        case 1:
                            if (!env && !process.env.environment && !process.env.ProjectId) {
                                throw new Error('noEnvProvided');
                            }
                            console.log('Using api-discovery for fetching env');
                            // Only set Interval if keepUpToDate is true ( use default if not defined)
                            // after it was executed once it will call init with keepUpToDate = false
                            // periodically (Interval default 5 minutes)
                            keepUpToDate = keepUpToDate !== undefined ? keepUpToDate : this.KeepUpToDateDefault;
                            if (keepUpToDate) {
                                setInterval(this.init, this.Interval, env, false);
                            }
                            apis_1 = {};
                            source = 'NONE';
                            i = 0;
                            _b.label = 2;
                        case 2:
                            if (!(i < this.DefaultURLs.length * this.Retry)) return [3 /*break*/, 7];
                            index = i % this.DefaultURLs.length;
                            baseUrl = this.DefaultURLs[index].replace('ENVIRONMENT', environment);
                            url = "".concat(baseUrl, "/service/").concat(environment);
                            _b.label = 3;
                        case 3:
                            _b.trys.push([3, 5, , 6]);
                            return [4 /*yield*/, axios_1.default.get(url)];
                        case 4:
                            apis_1 = (_b.sent()).data;
                            if (apis_1) {
                                source = url;
                                return [3 /*break*/, 7];
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            err_1 = _b.sent();
                            return [3 /*break*/, 6];
                        case 6:
                            i++;
                            return [3 /*break*/, 2];
                        case 7:
                            if (!apis_1) {
                                throw new Error('noServiceRespond');
                            }
                            Object.keys(apis_1).forEach(function (entry) {
                                process.env[entry] = apis_1[entry];
                                _this[entry] = apis_1[entry];
                            });
                            this.source = source;
                            _b.label = 8;
                        case 8: return [2 /*return*/, this];
                    }
                });
            });
        };
        this.getTime = function () { return __awaiter(_this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/time");
                        return [4 /*yield*/, axios_1.default.get(url)];
                    case 1:
                        res = _a.sent();
                        if (res.status === 200) {
                            return [2 /*return*/, res.data.now];
                        }
                        return [2 /*return*/, false];
                }
            });
        }); };
    }
    return Discovery;
}());
exports.Discovery = Discovery;
var discovery = new Discovery();
exports.default = discovery;
exports.Server = Discovery;
//# sourceMappingURL=Server.js.map